import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _530c9a5e = () => interopDefault(import('../pages/Blog.vue' /* webpackChunkName: "pages/Blog" */))
const _523afed8 = () => interopDefault(import('../pages/boarding.vue' /* webpackChunkName: "pages/boarding" */))
const _5c0652f8 = () => interopDefault(import('../pages/Boarding.vue' /* webpackChunkName: "pages/Boarding" */))
const _b04427a2 = () => interopDefault(import('../pages/compilations/index.vue' /* webpackChunkName: "pages/compilations/index" */))
const _40e870f0 = () => interopDefault(import('../pages/en/index.vue' /* webpackChunkName: "pages/en/index" */))
const _897a95ec = () => interopDefault(import('../pages/Faq.vue' /* webpackChunkName: "pages/Faq" */))
const _db66d574 = () => interopDefault(import('../pages/Gallery.vue' /* webpackChunkName: "pages/Gallery" */))
const _4ad50a50 = () => interopDefault(import('../pages/Offer.vue' /* webpackChunkName: "pages/Offer" */))
const _1cffa41d = () => interopDefault(import('../pages/Profile.vue' /* webpackChunkName: "pages/Profile" */))
const _31960dee = () => interopDefault(import('../pages/SiteMap.vue' /* webpackChunkName: "pages/SiteMap" */))
const _5d5b8325 = () => interopDefault(import('../pages/TermsOfUse.vue' /* webpackChunkName: "pages/TermsOfUse" */))
const _658278d9 = () => interopDefault(import('../pages/oauth/callback.vue' /* webpackChunkName: "pages/oauth/callback" */))
const _890f5524 = () => interopDefault(import('../pages/additional/_id.vue' /* webpackChunkName: "pages/additional/_id" */))
const _155d962e = () => interopDefault(import('../pages/blog/_id.vue' /* webpackChunkName: "pages/blog/_id" */))
const _74f2b636 = () => interopDefault(import('../pages/collection/_id.vue' /* webpackChunkName: "pages/collection/_id" */))
const _1a21cdc8 = () => interopDefault(import('../pages/compilations/_section/index.vue' /* webpackChunkName: "pages/compilations/_section/index" */))
const _6da4768b = () => interopDefault(import('../pages/masterpiece/_id.vue' /* webpackChunkName: "pages/masterpiece/_id" */))
const _9db4f230 = () => interopDefault(import('../pages/profile/_section.vue' /* webpackChunkName: "pages/profile/_section" */))
const _104fe819 = () => interopDefault(import('../pages/compilations/_section/_code/index.vue' /* webpackChunkName: "pages/compilations/_section/_code/index" */))
const _2f59cde6 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/app/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/Blog",
    component: _530c9a5e,
    name: "Blog"
  }, {
    path: "/boarding",
    component: _523afed8,
    name: "boarding"
  }, {
    path: "/Boarding",
    component: _5c0652f8,
    name: "Boarding"
  }, {
    path: "/compilations",
    component: _b04427a2,
    name: "compilations"
  }, {
    path: "/en",
    component: _40e870f0,
    name: "en"
  }, {
    path: "/Faq",
    component: _897a95ec,
    name: "Faq"
  }, {
    path: "/Gallery",
    component: _db66d574,
    name: "Gallery"
  }, {
    path: "/Offer",
    component: _4ad50a50,
    name: "Offer"
  }, {
    path: "/Profile",
    component: _1cffa41d,
    name: "Profile"
  }, {
    path: "/SiteMap",
    component: _31960dee,
    name: "SiteMap"
  }, {
    path: "/TermsOfUse",
    component: _5d5b8325,
    name: "TermsOfUse"
  }, {
    path: "/oauth/callback",
    component: _658278d9,
    name: "oauth-callback"
  }, {
    path: "/additional/:id?",
    component: _890f5524,
    name: "additional-id"
  }, {
    path: "/blog/:id?",
    component: _155d962e,
    name: "blog-id"
  }, {
    path: "/collection/:id?",
    component: _74f2b636,
    name: "collection-id"
  }, {
    path: "/compilations/:section",
    component: _1a21cdc8,
    name: "compilations-section"
  }, {
    path: "/masterpiece/:id?",
    component: _6da4768b,
    name: "masterpiece-id"
  }, {
    path: "/profile/:section?",
    component: _9db4f230,
    name: "profile-section"
  }, {
    path: "/compilations/:section/:code",
    component: _104fe819,
    name: "compilations-section-code"
  }, {
    path: "/",
    component: _2f59cde6,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
